// Last-seen dashboard snapshot per user → instant first paint, refreshed in background.
const KEY = (uid) => `solano_dash_cache_${uid || "anon"}`;

export function readDashCache(uid) {
  try {
    const raw = localStorage.getItem(KEY(uid));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function writeDashCache(uid, patch) {
  try {
    const cur = readDashCache(uid) || {};
    const next = { ...cur, ...patch, saved_at: Date.now() };
    if (Array.isArray(next.foodLogs)) {
      // Photos are large; keep the snapshot small so reads stay instant.
      next.foodLogs = next.foodLogs.map(({ photo_base64, ...rest }) => rest);
    }
    localStorage.setItem(KEY(uid), JSON.stringify(next));
  } catch { /* quota / private mode */ }
}

export function clearDashCache(uid) {
  try { localStorage.removeItem(KEY(uid)); } catch { /* noop */ }
}
